import moment from 'moment';

export class ApiCourseSessionUpdate {
    session_pk: number;
    session_name: string;
    session_description: string;
    session_begin_ts: string;
    session_end_ts: string;
    check_in_ts: string;
    min_attendance: number;
    max_attendance: number;
    sort_order: number;
    required: boolean;
    status_id: number;
    delivery_method_id: number;
    topic_keywords: string;
    private_url: string;
    eeds_ain: string;
    landing_page: boolean;
    join_url: string;
    docebo: {[name: string]: boolean};
    zoom: {[name: string]: boolean};
    

    constructor(data) {
        if (data.id) this.session_pk = data.id;
        this.session_name = data.name;
        this.session_description = data.description;
        this.session_begin_ts = data.startDate != null && moment(data.startDate).isValid() ? moment(data.startDate).format('YYYY-MM-DD HH:mm:ss') : "";
        this.session_end_ts = data.endDate != null && moment(data.endDate).isValid() ? moment(data.endDate).format('YYYY-MM-DD HH:mm:ss') : "";
        this.check_in_ts = data.checkInDate != null && moment(data.checkInDate).isValid() ? moment(data.checkInDate).format('YYYY-MM-DD HH:mm:ss') : "";
        this.min_attendance = data.minAttendance ? data.minAttendance : 0;
        this.max_attendance = data.maxAttendance ? data.maxAttendance : 0;
        this.sort_order = data.sortOrder != null ? data.sortOrder : "";
        this.required = data.required ? data.required : false;
        this.status_id = data.status;
        this.delivery_method_id = data.deliveryMethod;
        this.topic_keywords = data.topicKeywords;
        this.private_url = data.privateUrl;
        this.eeds_ain = data.eedsAin;
        this.landing_page = data.landingPage;
        this.join_url = data.joinUrl;
        if ("docebo" in data) {
            this.docebo = {
                status: data.docebo, 
                show_open: data.doceboShowOpen
            };
        }
        if ("zoom" in data) {
            this.zoom = {
                status: data.zoom, 
                show_open: data.zoomShowOpen
            };
        }
    }
}
